import { AxiosError } from 'axios';
import { createContext, MutableRefObject } from 'react';
import { IUser } from 'sierra';
import { ApiError } from '../interfaces/Api';

export type TAuthFetchUserFunction = ({ onError, onSuccess }: { onError?: (err: ApiError) => void, onSuccess?: () => void }) => void;
export type TAuthLoginFunction = (email: string, password: string, { onError, onSuccess }: { onError?: (err: ApiError) => void, onSuccess?: () => void }) => void;
export type TAuthLogoutFunction = (callback?: () => void) => void;

export interface IAuthContext {
    user: IUser | null;
    userLoaded: boolean;
    fetchUser: (callback?: () => void) => void;
    login: TAuthLoginFunction;
    logout: (callback?: () => void) => void;
}

export const AuthContext = createContext<IAuthContext | undefined>(undefined);